module.exports = __webpack_public_path__ + "static/media/gas-station.3be87334.svg";